export interface NavigationItem {
  menu: string;
  translate?: string;
  icon?: string;
  hidden?: boolean;
  link: string;
  backLink?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  task?: string;
  iconBreadcrumb?: string;
}

export const NavigationItems: NavigationItem[] = [
  {
    link: "/layout/dashboard",
    icon: "activity",
    menu: "Dashboard",
    backLink: "/layout/dashboard",
    iconBreadcrumb: "home",
  },
  {
    link: "/layout/school-program",
    icon: "layers",
    menu: "School Program",
    task: 'SCHOOL_PROGRAM_VIEW',
    backLink: "/layout/dashboard",
  },
  {
    link: "/layout/activity/add",
    icon: "dribbble",
    menu: "Activity Add",
    task: 'SCHOOL_PROGRAM_ACTIVITY_VIEW',
    backLink: "/layout/activity",
  },
  {
    link: "/layout/activity/edit",
    icon: "dribbble",
    menu: "Activity Edit",
    task: 'SCHOOL_PROGRAM_ACTIVITY_VIEW',
    backLink: "/layout/activity",
  },
  {
    link: "/layout/activity",
    icon: "dribbble",
    menu: "Activity",
    task: 'SCHOOL_PROGRAM_ACTIVITY_VIEW',
    backLink: "/layout/dashboard",
  },
  {
    link: "/layout/global-rules/rules",
    icon: "lock",
    menu: "Rules",
    task: 'SCHOOL_PROGRAM_RULE_VIEW',
    backLink: "/layout/global-rules",
  },
  {
    link: "/layout/global-rules",
    icon: "lock",
    menu: "Global Rules",
    task: 'SCHOOL_PROGRAM_RULE_VIEW',
    backLink: "/layout/dashboard",
  },
  {
    link: "/layout/online-registration",
    icon: "edit",
    menu: "Registration",
    task: 'SCHOOL_PROGRAM_REGISTRATION_VIEW',
    backLink: "/layout/dashboard",
  },
  {
    link: "/layout/registration-payment",
    icon: "credit-card",
    menu: "Payment",
    task: 'EXTRACURRICULAR_PARTICIPANT_MANAGE_PARTICIPANT',
    backLink: "/layout/dashboard",
  },
  {
    link: "/layout/registration-payment",
    icon: "dollar-sign",
    menu: "Payment Log",
    task: 'SCHOOL_PROGRAM_REGISTRATION_PAYMENT_VIEW',
    backLink: "/layout/dashboard",
  },
  {
    link: "/layout/payment-va",
    icon: "credit-card",
    menu: "Payment VA",
    task: 'SCHOOL_PROGRAM_REGISTRATION_PAYMENT_VA_VIEW',
    backLink: "/layout/dashboard",
  },
  {
    link: "/layout/payment-va/accumulation-setup",
    icon: "check-square",
    menu: "Accumulation Setup",
    backLink: "/layout/payment-va",
  },
  {
    link: "/layout/activity-approver",
    icon: "check-circle",
    menu: "Approver",
    task: 'SCHOOL_PROGRAM_APPROVER_VIEW',
    backLink: "/layout/dashboard",
  },
  {
    link: "/layout/registration-approver",
    icon: "user-check",
    menu: "Registration Approver",
    task: 'SCHOOL_PROGRAM_REGISTRATION_APPROVER_VIEW',
    backLink: "/layout/dashboard",
  },
  {
    link: "/layout/activity-approver",
    icon: "check-square",
    menu: "Activity Approver",
    task: 'SCHOOL_PROGRAM_ACTIVITY_APPROVER_VIEW',
    backLink: "/layout/dashboard",
  },
  {
    link: "/layout/period-setup",
    icon: "tool",
    menu: "Period Setup",
    task: 'SCHOOL_PROGRAM_SETUP_VIEW',
    backLink: "/layout/dashboard",
  },
  {
    link: "/layout/approver-setup",
    icon: "thumbs-up",
    menu: "Approver Setup",
    task: 'SCHOOL_PROGRAM_APPROVER_SETUP_VIEW',
    backLink: "/layout/dashboard",
  },
  {
    link: "/layout/period-setup",
    icon: "calendar",
    menu: "Period Setup",
    task: 'SCHOOL_PROGRAM_PERIOD_SETUP_VIEW',
    backLink: "/layout/dashboard",
  },
  {
    link: "/layout/coach",
    icon: "users",
    menu: "Coach",
    task: 'SCHOOL_PROGRAM_COACH_VIEW',
    backLink: "/layout/dashboard",
  },
  {
    link: "/layout/coach/detail",
    icon: "users",
    menu: "Coach Detail",
    task: 'SCHOOL_PROGRAM_COACH_VIEW',
    backLink: "/layout/coach",
  },
  {
    link: "/layout/attendance",
    icon: "clock",
    menu: "Attendance Session",
    task: 'SCHOOL_PROGRAM_ATTENDANCE_VIEW',
    backLink: "/layout/dashboard",
  },
  {
    link: "/layout/attendance/attendance-list",
    icon: "clock",
    menu: "Attendance List",
    task: 'SCHOOL_PROGRAM_ATTENDANCE_VIEW',
    backLink: "/layout/attendance",
  },
  {
    link: "/layout/scoring",
    icon: "hash",
    menu: "Scoring",
    task: 'SCHOOL_PROGRAM_SCORING_VIEW',
    backLink: "/layout/dashboard",
  },
  {
    link: "/layout/payment-student",
    icon: "credit-card",
    menu: "Payment Details",
    task: 'SCHOOL_PROGRAM_REGISTRATION_PAYMENT_STUDENT_VIEW',
    backLink: "/layout/dashboard",
  },
  {
    link: "/layout/report-unregistered",
    icon: "file-text",
    menu: "Report Unregistered",
    task: 'SCHOOL_PROGRAM_REPORT_UNREGISTERED_VIEW',
    backLink: "/layout/dashboard",
  },
];